import { render, staticRenderFns } from "./ActivityPoster.vue?vue&type=template&id=86819f5c&scoped=true"
import script from "./ActivityPoster.vue?vue&type=script&lang=ts"
export * from "./ActivityPoster.vue?vue&type=script&lang=ts"
import style0 from "./ActivityPoster.vue?vue&type=style&index=0&id=86819f5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86819f5c",
  null
  
)

export default component.exports